export class JwtHelper {
  static getPayload(token: string): any {
    try {
      const base64Url = token.split('.')[1];
      return JSON.parse(window.atob(base64Url));
    } catch (e) {
      return null;
    }
  }
}
